import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-11d622fd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  ref: "wrapper",
  class: "captcha-wrapper"
};
const _hoisted_2 = {
  ref: "captchaButton",
  id: "captcha-button",
  style: {
    "display": "none"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "captcha-element"
}, null, -1));
const _hoisted_4 = {
  key: 0,
  class: "captcha-error"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", _hoisted_2, null, 512), _hoisted_3, $data.error ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString($data.error), 1), _createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.initCaptcha && $options.initCaptcha(...args)),
    class: "retry-btn"
  }, "重试")])) : _createCommentVNode("", true)], 512);
}